import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const financialAccountParameter = 'financial-account' as const;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const financialAccountTransactionsParams = [financialAccountParameter] as const;

type FinancialAccountTransactionsParams =
  (typeof financialAccountTransactionsParams)[number];
export type FinancialAccountTransactionsHtmlParams = Partial<
  Record<FinancialAccountTransactionsParams, string>
>;

export const FinancialAccountTransactionsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryFinancialAccount" */
      '../../../components/Treasury/TransactionsList'
    ),
  htmlAttributes: {
    [financialAccountParameter]: {
      isInternal: false,
    },
  },
  customHtmlElementMethods: {
    setFinancialAccount: {
      type: 'AttributeSettingMethod',
      attribute: financialAccountParameter,
      isInternal: false,
      description: 'Sets the financial account id to display transactions for.',
    },
  },
  releaseState: 'ga',
  sentryTeam: 'treasury_surfaces',
  teamOwner: 'baas-growth',
  description:
    'Displays the list of transactions for the given financial account.',
  friendlyName: 'Financial account transactions',
  docSitePath:
    '/connect/supported-embedded-components/financial-account-transactions',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-fatransactions-rc',
    rcTestUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-fatransactions-rc',
  },
};
